import { AxiosPromise } from 'axios';

import { BillsBillResponse } from './types';
import { baseClientConstructorProps } from '../config';
import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../generated/baseClient';

class SettlementAcceptedTermsClient extends BaseClient {
  private _namespace: string;

  constructor(props: BaseClientConstructorProps) {
    super(props);

    this._namespace = '/api/v1/settlement/accepted_terms';
  }

  readonly acceptTerms = (): AxiosPromise<BillsBillResponse> => {
    const sendRequestPayload: SendRequestPayload = {
      endpoint: `${this._namespace}/accept`,
      method: 'POST',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };
}

export const settlementAcceptedTermsClient = new SettlementAcceptedTermsClient(baseClientConstructorProps);
